import React, { useState } from "react";
import { Popconfirm, message, Empty, Tooltip } from "antd";
import PaginationTable from "../../../shared/PaginationTable";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import moment from "moment";

const LocationListView = props => {
  const {
    locationList,
    deleteLocation,
    editRetailLocation,
    onChangeStateValue,
    selectedOrgId,
  } = props;

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (name, record) => {
        return record.geoframe === null ? (
          <>
            {" "}
            <Tooltip title="No Geo Target">{name}</Tooltip>
          </>
        ) : (
          <>{name}</>
        );
      },
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (description, record) => {
        return record.geoframe === null ? (
          <>
            {" "}
            <Tooltip title="No Geo Target">{description}</Tooltip>
          </>
        ) : (
          <>{description}</>
        );
      },
    },
    {
      title: "Address",
      dataIndex: "formattedAddress",
      key: "formattedAddress",
      render: (formattedAddress, record) => {
        // Check if the address is available and not null
        if (formattedAddress) {
          // Remove leading commas and spaces from the address
          const cleanedAddress = formattedAddress.trim().replace(/^, */, "");

          return record.geoframe === null ? (
            <>
              {" "}
              <Tooltip title="No Geo Target">{cleanedAddress}</Tooltip>
            </>
          ) : (
            <>{cleanedAddress}</>
          );
        } else {
          return null; // Handle the case where the address is null or undefined
        }
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (email, record) => {
        return record.geoframe === null ? (
          <>
            {" "}
            <Tooltip title="No Geo Target">{email}</Tooltip>
          </>
        ) : (
          <>{email}</>
        );
      },
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      render: (phone, record) => {
        return record.geoframe === null ? (
          <>
            {" "}
            <Tooltip title="No Geo Target">{phone}</Tooltip>
          </>
        ) : (
          <>{phone}</>
        );
      },
    },
    {
      title: "Website",
      dataIndex: "url",
      key: "url",
      render: (url, record) => {
        return record.geoframe === null ? (
          <>
            {" "}
            <Tooltip title="No Geo Target">{url}</Tooltip>
          </>
        ) : (
          <>{url}</>
        );
      },
    },
    {
      title: "Date Created",
      dataIndex: "createdAt",
      key: "createdAt",
      render: text => {
        return moment(text).format("MM/DD/YYYY hh:mma");
      },
      sorter: (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),
    },
    {
      title: "Date Updated",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: text => {
        return moment(text).format("MM/DD/YYYY hh:mma");
      },
      sorter: (a, b) => moment(a.updatedAt).unix() - moment(b.updatedAt).unix(),
    },
    {
      title: "",
      key: "edit",
      width: "3%",
      render: (text, locations) => (
        <EditOutlined
          onClick={() => {
            editRetailLocation(locations);
          }}
        />
      ),
    },
    {
      title: "",
      key: "delete",
      width: "3%",
      render: (text, locations) => (
        <Popconfirm
          title="Are you sure you want to delete this Location?"
          onConfirm={e => {
            deleteLocation(locations.id);
          }}
          onCancel={e => {
            message.warning("cancelled");
          }}
          okText="Yes"
          cancelText="No"
        >
          <DeleteOutlined />
        </Popconfirm>
      ),
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);

  const table = (
    <div>
      <PaginationTable
        columns={columns}
        data={
          locationList
            ? locationList.filter(
                location =>
                  location.audienceType === "ATTRIBUTION" &&
                  location.org.id === selectedOrgId
              )
            : []
        }
        bordered={false}
        rowSelection={{
          type: "checkbox",
          getCheckboxProps: record => ({
            disabled: record.geoframe === null,
          }),
          onChange: (selectedRowKeys, selectedRows) => {
            onChangeStateValue("selectedLocations", selectedRows);
          },
        }}
        paginationSize={"default"}
        scroll={{ x: 1200 }}
        size={"default"}
        current={currentPage}
        pageSize={10}
        onChange={(paginationObject, filtersObject, sorterObject) => {
          setCurrentPage(paginationObject.current);
        }}
      />
    </div>
  );

  return locationList && locationList.length ? table : <Empty />;
};

export default LocationListView;
